import { PaginatedResponseData } from '../../api/client';

export default class PaginationHelpers {
  public static initPaginationData<T>(): PaginatedResponseData<T> {
    return {
      data: [],
      meta: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 0,
      },
    };
  }
}
